import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import DownloadButton from './DownloadButton';

const Section = styled.section`
  padding: 7rem 2rem;
  background: #0a0a0a;
  text-align: center;
`;

const Title = styled(motion.h2)`
  font-size: clamp(2.8rem, 7vw, 4.2rem);
  font-weight: 900;
  background: linear-gradient(135deg, #ffffff 0%, #00f5ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1.2rem;
  line-height: 1.1;
`;

const Subtitle = styled(motion.p)`
  font-size: 1.35rem;
  color: #bbbbff;
  max-width: 620px;
  margin: 0 auto 3rem;
  line-height: 1.6;
  opacity: 0.9;
`;

const ButtonsWrapper = styled(motion.div)`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Download = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Title>
          {t('download_title')}
        </Title>

        <Subtitle>
          {t('download_subtitle')}
        </Subtitle>

        <ButtonsWrapper
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <DownloadButton 
            onClick={() => window.open('https://apps.apple.com', '_blank')}
            style={{ minWidth: '200px' }}
          >
            {t('download_appstore')}
          </DownloadButton>

          <DownloadButton 
            onClick={() => window.open('https://play.google.com', '_blank')}
            style={{ minWidth: '200px' }}
          >
            {t('download_googleplay')}
          </DownloadButton>
        </ButtonsWrapper>
      </motion.div>
    </Section>
  );
};

export default Download;